// extracted by mini-css-extract-plugin
export default {"background":"Auth_background__rpBeu","logo_gif":"Auth_logo_gif__Vcm1W"};